import { selectProfileData } from '@pages/profile/store/selectors';
import { useSelector } from 'react-redux';
import { UseHandleUserService } from '../types';

const useHandleUserService = (): UseHandleUserService => {
  const userProfile = useSelector(selectProfileData);
  const { naturalPerson, isUserInactive } = userProfile || {};
  const { name, lastName } = naturalPerson || {};
  return { isUserInactive: !!isUserInactive, name, lastName };
};

export default useHandleUserService;
